import { reduce, map, pick, sortBy, toLower } from "lodash";

export const getStatusColor = status => {
  switch (status.toLowerCase()) {
    case "completed":
      return "green";
    default:
      return "gray";
  }
};

export const getCurrentStep = (offer, formName) => {
  const { stages } = offer;
  return reduce(
    stages,
    (currentStep, stage) => {
      const { steps } = stage;
      map(steps, step => {
        if (step.formName === formName) {
          currentStep = step;
        }
      });
      return currentStep;
    },
    {}
  );
};

export const getReferences = references => {
  return map(references, reference => {
    return (
      pick(reference, [
        "id",
        "type",
        "referenceTypeName",
        "periodStartDate",
        "periodEndDate",
        "referenceReceivedDate",
        "referee",
        "experience",
        "status",
        "conversations"
      ]) || {}
    );
  });
};

export const getReferee = referee => {
  return (
    pick(referee, [
      "id",
      "firstName",
      "lastName",
      "emailAddress",
      "phoneNumber",
      "jobTitle",
      "company"
    ]) || {}
  );
};

export const OFFER_STATUSES = {
  PENDING: "pending",
  APPROVED: "approved",
  PENDING_APPROVAL: "pending_approval",
  LIVE: "live",
  COMPLETE: "complete",
  WITHDRAWN: "withdrawn",
  DRAFT: "draft",
  REJECTED: "rejected"
};

export const getColorByStatus = status => {
  const {
    PENDING_APPROVAL,
    LIVE,
    COMPLETE,
    WITHDRAWN,
    PENDING,
    APPROVED,
    REJECTED
  } = OFFER_STATUSES;
  switch (toLower(status)) {
    case LIVE:
    case APPROVED:
      return "green";
    case COMPLETE:
      return "blue";
    case PENDING:
    case PENDING_APPROVAL:
      return "yellow";
    case WITHDRAWN:
    case REJECTED:
      return "red";
    default:
      return "gray";
  }
};

export const getSortedOfferGroups = offerGroups =>
  sortBy(offerGroups, ["displayOrder"]);

export const getIconByStatus = status => {
  switch (status) {
    case "approved":
    case "complete":
      return "mdi-check-circle";
    case "incomplete":
    case "resubmit":
      return "mdi-selection-ellipse";
    case "information":
      return "mdi-circle";
    default:
      return "mdi-sync-circle";
  }
};
